<template>
  <div
    class="admission-sub-info"
    v-if="getVisit.status === 'UPCOMING' || getVisit.status === 'OPEN'"
  >
    <p class="admission-sub-info__title">Данные о приёме</p>
    <div class="info-banner" v-if="!hasContract">
      <InfoIcon customColor class="icon" />
      <p>
        Вы не можете открыть визит удалённо. Необходимо заключить договор с
        клиникой. Перед визитом пройдите в регистратуру клиники.
        <span class="link" @click="limitModalHandler">Подробнее</span>
      </p>
    </div>
    <div class="visit-info" v-else>
      <div class="visit-info__description">
        <p v-if="!isShowVisit">
          Вы можете открыть визит и получить данные о кабинете для визита
        </p>
        <div v-else class="visit-info__description--mobile">
          <p>
            Врач примет вас в кабинете
            <span>{{ getCabinet }}</span>
          </p>
          <p>
            Начало приёма в
            <span>{{ getTime(getVisit.dateTime) }}</span>
          </p>
        </div>
      </div>
      <div class="info-banner">
        <InfoIcon customColor class="icon" />
        <p v-if="!visitError">
          Если вы опаздываете более чем на 15 мин., просим вас
          <span class="link" @click.stop="modalHandler"> перезаписаться </span>
        </p>
        <p v-else>
          <!-- {{ visitError }} -->
          Вы можете открыть визит не ранее, чем за 25 минут и не позднее, чем
          через 5 минут после начала приёма.
          <br />
          <br />
          Открытие визита доступно при заключённом договоре с клиникой.
        </p>
      </div>
      <div class="visit-info__open-btn-wrapper" v-if="!isShowVisit">
        <Button
          class="open-btn"
          v-if="!isShowVisit"
          :onClick="showVisitHandler"
        >
          Открыть визит
        </Button>
        <Button
          class="open-visit-info"
          :onClick="() => (this.isOpenVisitInfo = true)"
        >
          <InfoIcon customColor class="open-visit-info--icon" />
        </Button>
      </div>
    </div>
    <CustomModal title="Открытие визита" v-model="isOpenVisitInfo">
      <IconCard type="succes">
        При открытии визита вы узнаете номер кабинета врача по вашей записи.
        <br />
        <br />
        Открытие визита доступно при заключённом договоре с клиникой.</IconCard
      >
    </CustomModal>
    <CustomModal title="Визит открыт успешно!" v-model="isOpenVisit">
      <div class="open-modal">
        <div class="open-modal__wrap">
          <div
            v-for="visit in openVisitsInfo"
            :key="visit.id"
            class="open-modal__cart"
          >
            <span>{{ visit.specialization }}</span>
            <span>Кабинет - {{ visit.cabinet }}</span>
            <span>Время приёма - {{ visit.time }}</span>
          </div>
        </div>

        <div class="open-modal__footer">
          <Button
            :onClick="() => (isOpenVisit = false)"
            class="open-modal__footer--btn"
          >
            Закрыть окно
          </Button>
          <ShareEventButton :shareText="getShareText">
            <template v-slot="{ event }">
              <div @click.stop="event" class="open-modal__footer--icon">
                <ShareIcon />
              </div>
            </template>
          </ShareEventButton>
        </div>
      </div>
    </CustomModal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { parseISO } from 'date-fns'

import { CustomModal, IconCard } from '@/shared'
import { TRACKER_SLUGS } from '@/models/tracker'
import { formatWithLocale } from '@/core/utils'

import Button from '@/components/button'
import ShareEventButton from '@/components/shareEventButton'
import InfoIcon from '@/assets/icons/info'
import ShareIcon from '@/assets/icons/share'

export default {
  name: 'AdmissionSubInfo',
  components: {
    IconCard,
    Button,
    CustomModal,
    InfoIcon,
    ShareIcon,
    ShareEventButton
  },
  props: ['visitData', 'hasContract', 'groupInfo'],
  emits: ['onOpen'],
  data() {
    return {
      isOpenVisit: false,
      isOpenVisitInfo: false,
      showVisit: false,
      visitError: '',
      visitCabinet: null
    }
  },
  methods: {
    ...mapActions('visits', ['openVisit']),
    limitModalHandler() {
      this.$modals.show('limit-modal')
    },
    modalHandler(type) {
      const { specialityId, id, doctorId, patient } = this.getVisit

      if (type === 'cancel') {
        this.$tracker(TRACKER_SLUGS.CANCEL_VISIT)
        this.$modals.show('cancel-modal')
      } else if (type === 'transfer') {
        this.$tracker(TRACKER_SLUGS.RESCHEDULE_VISIT)
        this.$router.push(
          `/appointment/${specialityId}/${doctorId}?visitId=${id}&cityId=${patient.cityId}`
        )
      } else {
        this.$tracker(TRACKER_SLUGS.PROCEED_VISIT)
        this.$router.push(`/appointment/${specialityId}/${doctorId}`)
      }
    },
    showVisitHandler() {
      this.$tracker(TRACKER_SLUGS.PROCEED_VISIT)
      this.openVisit({ id: this.getVisit.id })
        .then(({ data }) => {
          if (data.errorCode) {
            this.visitError = data.description
          } else {
            this.$emit('onOpen', { cabinet: data.visit.cabinet })
            this.visitCabinet = data.visit.cabinet
            this.showVisit = true
            this.isOpenVisit = true
          }
        })
        .catch(() => {
          this.visitError = 'Неизвестная ошибка. Попробуйте позже'
        })
    },
    getTime(dateTime) {
      return formatWithLocale(parseISO(dateTime), 'p')
    }
  },
  computed: {
    ...mapGetters('account', ['getPatientInfo']),
    ...mapGetters('specialities', ['specialitiesListData']),
    getCabinet() {
      return this.visitCabinet ?? this.getVisit.cabinet
    },
    isShowVisit() {
      return this.showVisit || this.getVisit.status === 'OPEN'
    },
    openVisitsInfo() {
      const visits = []
      for (const info of this.groupInfo) {
        visits.push({
          specialization: this.specialitiesListData.find(
            (v) => v.id === info.specialityId
          )['title'],
          cabinet: info.cabinet,
          time: this.getTime(info.dateTime)
        })
      }
      return visits
    },
    getShareText() {
      const patient = this.getPatientInfo

      let text = ''

      if (patient.surname && patient.name && patient.patronymic) {
        text += `${patient.surname} ${patient.name} ${patient.patronymic}`
      }

      for (const visit of this.visitData) {
        const clinic = visit['clinic'] || visit['clinicInfo']

        const subwayStations = () => {
          const stations = clinic['subway-stations'] || []
          return stations
            .map((v) => (v.title ? `м. ${v.title}\n` : ''))
            .join('')
        }

        const formattedDate = formatWithLocale(
          parseISO(visit.dateTime),
          'eeee, d MMMM, HH:mm'
        )

        const date =
          formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1)

        const specialization = this.specialitiesListData.find(
          (v) => v.id === visit.specialityId
        )

        if (clinic.address) {
          text += `\n\nСМ-клиника на улице: ${
            clinic.address
          }\n${subwayStations()}`
        }

        if (
          visit.doctor.surname &&
          visit.doctor.name &&
          visit.doctor.patronymic
        ) {
          text += `${visit.doctor.surname} ${visit.doctor.name} ${visit.doctor.patronymic}`
        }

        if (specialization.title) {
          text += `\n${specialization.title}`
        }

        text += `\n${date}`

        if (visit.cabinet && visit.status !== 'UPCOMING') {
          text += `\n${visit.cabinet}`
        }
      }

      return text
    },
    getVisit() {
      return Array.isArray(this.visitData) ? this.visitData[0] : this.visitData
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'style.scss';
</style>
